module.exports = __webpack_public_path__ + "img/videos.8d4876b4.jpg";